import { jsonApiVuex } from '@common/store/json-api-vuex';

const getters = {
  activeSegments(state) {
    return state.entities.filter(segment => !segment.archived);
  },
};

export const dmsSegment = jsonApiVuex('dms/segment', { getters }, {});
